module.exports = __webpack_public_path__ + "static/media/gts11.1a98aea1.png";